import controller from './controller';

const template = require('./waterDetector.html');

export default {
    bindings: {
        device: '<',
        onPublishEvent: '&'
    },
    controller,
    template
};
